<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true">
    </loading>
    <v-row class="text-left search-bar">
      <v-col class="pt-4 pl-0">
        <v-tabs class="ml-6 tabsLeft" color="#215DA7">
          <v-tabs-slider color="#215DA7"></v-tabs-slider>
          <v-tab @click="showInfo=0"><span style="font-size:15pt; font-weight:550">修改帳號資料</span></v-tab>
          <v-tab @click="showInfo=1"><span style="font-size:15pt; font-weight:550">修改密碼</span> </v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <div v-if="showInfo==0" id="router" :style="viewStyle">
      <div id="box" class="pa-5" style="margin-top:3%">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
          <h4 class="DarkBlue pt-1">帳號資料</h4>
        </v-row>
        <v-row class="mx-2">
          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>中文姓名</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense background-color="#F4F8F9" readonly outlined placeholder="請輸入" v-model="memberInfo.name"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 py-1">
              <v-col class="px-0 col-2 col-md-4">
                <div class="word">國籍</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0 pt-2 pl-5">
                <v-radio-group class="ma-0 pa-0" dense disabled v-model="memberInfo.citizenShip">
                  <v-row>
                    <v-radio v-for="(data,index) in citizenShipList" :key="index" :value = "(index+1).toString()" class="pr-2" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">{{data.title}}</span>
                      </template>
                    </v-radio>
                  </v-row>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>羅馬拼音</div>
              </v-col>
              <v-col class="col-8 col-md-6">
                <v-text-field class="text_field" dense background-color="white" outlined placeholder="請務必填寫正確" maxlength="50" v-model="memberInfo.englishName"
                @keyup="memberInfo.englishName = memberInfo.englishName.replace(/[\u4e00-\u9fa5]/ig,''), memberInfo.englishName = $Global.toCDB(memberInfo.englishName)"></v-text-field>
              </v-col>
              <v-col class="pa-0 pt-2 ml-n2 col-2">
                <a href="https://www.boca.gov.tw/sp-natr-singleform-1.html" target="_blank" class="pt14">同護照</a>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>身分證字號(ID)</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense background-color="#F4F8F9" readonly outlined v-model="memberInfo.idCard"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>出生年月日</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="memberInfo.birthday"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>學校類別</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-select class="text_field" dense background-color="white" outlined placeholder="請選擇學校類別" :items="collegeCategoryList" item-text="title" item-value="valuev" v-model="memberInfo.collegeCategory"></v-select>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>學校/單位名稱</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-autocomplete v-if="memberInfo.collegeCategory!='4'" class="text_field autocomplete" placeholder="請選擇學校名稱"
                :items="schoolList" item-text="name" item-value="name" v-model="memberInfo.company"></v-autocomplete>
                <v-text-field v-if="memberInfo.collegeCategory=='4'" class="text_field" dense background-color="white" outlined placeholder="請輸入單位名稱" maxlength="50" v-model="memberInfo.company"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>系所/部門</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入系所/部門" maxlength="50" v-model="memberInfo.department"></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0 pb-1">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>性別</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0 pt-2 pl-5">
                <v-radio-group class="ma-0 pa-0" dense v-model="memberInfo.gender">
                  <v-row>
                    <v-radio class="pr-2" value="0" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">女</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="1" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">男</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="2" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">不提供</span>
                      </template>
                    </v-radio>
                  </v-row>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>電子信箱</div>
              </v-col>
              <v-col class="col-10 col-md-8">
              <email-auto-complete ref="EmailAutoComplete" :onCompletion='(val) => memberInfo.email = val' :domains='mailCandidateList'>
                <input class="emailAutoComplete" type="text" placeholder="請輸入電子信箱" maxlength="50" v-model='memberInfo.email'
                @keyup="[$refs.EmailAutoComplete.check($event), memberInfo.email= memberInfo.email.replace(/[\u4e00-\u9fa5]/ig,''), memberInfo.email = $Global.toCDB(memberInfo.email)]" />
                </email-auto-complete>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14">聯絡電話</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense background-color="white" outlined placeholder="02-0000-0000" maxlength="30" v-model="memberInfo.tel"
                @keyup="memberInfo.tel = memberInfo.tel.replace(/[\u4e00-\u9fa5]/ig,'') && memberInfo.tel.toUpperCase(), memberInfo.tel = $Global.toCDB(memberInfo.tel)"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>行動電話</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense background-color="white" outlined placeholder="0900000000" maxlength="10" v-model="memberInfo.ctel"
                @keyup="[memberInfo.ctel= memberInfo.ctel.replace(/\D/g,'')]"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0" v-if="memberInfo.citizenShip=='1' || !memberInfo.citizenShip">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>郵遞區號</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined placeholder="自動顯示" v-model="memberInfo.zipCode"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>通訊地址</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-row class="px-3" v-if="memberInfo.citizenShip=='1' || !memberInfo.citizenShip">
                  <v-select class="text_field mr-2" dense background-color="white" outlined placeholder="請選擇縣市" :items="countryList" item-text="country" item-value="country" style="width:48%" v-model="memberInfo.country"></v-select>
                  <v-select class="text_field" dense background-color="white" outlined placeholder="請選擇行政區" :items="areaList" item-text="area" item-value="area" style="width:48%" v-model="memberInfo.area"></v-select>
                </v-row>
                <v-row class="px-3">
                  <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入詳細地址" maxlength="200" v-model="memberInfo.address"></v-text-field>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mx-2 py-1">
          <v-col class="px-0 col-2">
            <div class="text-right pt-2 pt14"><span class="start">*</span>職稱</div>
          </v-col>
          <v-col v-if="memberType=='erpMember'" class="py-0 pt-2 pl-5 col-10 col-md-9">
            <v-radio-group class="ma-0 pa-0" dense v-model="memberInfo.jobtitle">
              <v-row>
                <v-radio class="pr-2" value="1" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">高中生(含五專)</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="2" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">大學生</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="3" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">碩士生</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="4" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">博士生</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="5" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">教師</span>
                  </template>
                </v-radio>
                <v-radio class="pr-2" value="6" color="#215DA7">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">社會人士</span>
                  </template>
                </v-radio>
              </v-row>
            </v-radio-group>
          </v-col>
          <v-col v-if="memberType!='erpMember'" class="col-10 col-md-9">
            <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入職稱" maxlength="50" v-model="memberInfo.jobtitle"></v-text-field>
          </v-col>
        </v-row>
      </div>
      <div class="mt-8"> 
        <v-row class="ma-0 pa-0" justify="center">
          <v-btn class="mb-5 col-8 col-sm-5 col-md-4 col-lg-3" outlined style="width:22%; height:40px; background:#81c0e2; border-radius:8px; border:none" 
          @click="setMemberDataset()">
            <span style="color:#FFFFFF">送出修改帳號資料</span>
          </v-btn>
        </v-row>
      </div>
    </div>

    <div v-if="showInfo==1" id="router" :style="viewStyle">
      <div id="box" class="pa-5" style="margin-top:3%">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
          <h4 class="DarkBlue pt-1">帳號密碼</h4>
        </v-row>
        <v-row class="mx-2">
          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>帳號(身分證字號)</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense background-color="#F4F8F9" readonly outlined v-model="memberInfo.idCard"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>預設密碼</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense background-color="#F4F8F9" readonly outlined v-model="memberInfo.birthday"></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>舊密碼</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入舊密碼" v-model="passwdOld"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>新密碼</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense background-color="white" outlined placeholder="4~10個英文字母或數字" maxlength="10" v-model="passwdNew"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>確認新密碼</div>
              </v-col>
              <v-col class="col-10 col-md-8">
                <v-text-field class="text_field" dense background-color="white" outlined placeholder="4~10個英文字母或數字" maxlength="10" v-model="passwdNewCheck"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <div class="mt-8"> 
        <v-row class="ma-0 pa-0" justify="center">
          <v-btn class="mb-5 col-8 col-sm-5 col-md-4 col-lg-3" outlined style="height:40px; background:#81c0e2; border-radius:8px; border:none"
          @click="erpMemberPasswordChange()">
            <span style="color:#FFFFFF">送出修改密碼</span>
          </v-btn>
        </v-row>
      </div>
    </div>
    <ShowMsg ref="ShowMsg" />
  </div>
</template>

<script>
import CryptoJS from "crypto-js"
import EmailAutoComplete from "vue-email-autocomplete";
import "vue-email-autocomplete/dist/vue-email-autocomplete.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.min.css';
import ShowMsg from '@/dialogs/ShowMsg'

export default {
  name: 'Profile',
  components: {EmailAutoComplete,Loading,ShowMsg},
  mounted(){
    this.$Global.getCollegeCategoryList().then(res=>{ this.collegeCategoryList = res })
    this.$Global.getCountryList().then(res=>{ this.countryList = res })
    this.$Global.getCitizenShipList().then(res=>{ this.citizenShipList = res })
    this.$Global.getMailCandidateList().then(res=>{ this.mailCandidateList = res })
    this.getMemberInfo()
    this.memberType = (sessionStorage.getItem('cerpsMemberType').includes('erpMember')) ? 'erpMember' : 'erpTeacher'
    setTimeout(() => { this.initDone = true; }, 1000); //delay 1s
  },
  data:() => ({
    datasets: [],
    viewStyle:{},
    showInfo:0,
    memberInfo: {},
    memberType:'',
    initDone: false,
    isLoading: false,

    collegeCategoryList: [],
    schoolList: [],
    countryList: [],
    areaList: [],
    mailCandidateList: [],
    citizenShipList: [],

    passwdOld:'',
    passwdNewCheck:'',
    passwdNew:'',
    requiredField:['name','englishName','idCard','birthday','collegeCategory','company','department','gender','email','ctel','address','jobtitle'],
    requiredFieldOther:['zipCode','country','area'],
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{
    "memberInfo.collegeCategory":function(){
      this.$Global.getSchoolList(this.memberInfo.collegeCategory, true).then(res=>{ this.schoolList = res })
    },
    "memberInfo.country":function(){
      if(this.initDone){
        this.memberInfo.zipCode = ''
      }
      this.$Global.getAreaListByCountryList(this.memberInfo.country).then(res=>{ this.areaList = res })
    },
    "memberInfo.area":function(){
      this.memberInfo.zipCode = this.$Global.getZipCode(this.areaList, this.memberInfo.area, this.memberInfo.zipCode)
    },
  },
  computed:{
    isPasswdNewMatch() {
      return this.passwdNew == this.passwdNewCheck
    },
  },
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-128 + 'px'}
    },
    redirectPath(path){
      this.$router.push(path)
    },
    getMemberInfo(){
      var self = this
      var request = {
        method: 'GET',
        url: ((sessionStorage.getItem('cerpsMemberType').includes('erpMember')) ? '/erpMember/' : '/erpTeacher/') + sessionStorage.getItem('cerpsMemberId'),
        params: {},
      }
      this.$http(request).then(function(response) {
        self.memberInfo = response.data.data
      }).catch(()=>{
        console.log('系統錯誤','請聯繫系統管理人員，編號為Pfl-7956')
      })
    },
    setMemberDataset(){
      if(!this.$Global.checkForm(this.memberInfo,this.requiredField)){
        this.$refs.ShowMsg.open(1)
        return
      }
      if(this.memberInfo.citizenShip=='1' || !this.memberInfo.citizenShip){
        if(!this.$Global.checkForm(this.memberInfo,this.requiredFieldOther)){
          this.$refs.ShowMsg.open(1)
          return
        }
      }

      //更新 updateId
      this.memberInfo.updateId = sessionStorage.getItem('cerpsMemberIdCard')

      var self = this
      var request = {
        method: 'PUT',
        url: ((sessionStorage.getItem('cerpsMemberType').includes('erpMember')) ? '/erpMember' : '/erpTeacher'),
        data: this.Qs.stringify(this.memberInfo)
      }
      this.isLoading = true;
      this.$http(request).then(function(response) {
        // console.log(response)
        self.$refs.ShowMsg.open(11)
      }).catch(()=>{
        this.isLoading = false
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Pfl-7957')
      }).finally(()=>{
        this.isLoading = false
        // setTimeout(() => {
        //   this.isLoading = false
        // },5000)
      })
    },
    erpMemberPasswordChange(){
      if(!this.passwdOld || !this.passwdNew || !this.passwdNewCheck){
        this.$refs.ShowMsg.open(1)
        return false
      }
      if(this.passwdNew.length < 4 || this.passwdNewCheck.length < 4){
        this.$refs.ShowMsg.open(14)
        return false
      }
      if(!this.isPasswdNewMatch){
        this.$refs.ShowMsg.open(15)
        return false
      }
      var self = this
      var request = {
        method: 'PUT',
        url: ((sessionStorage.getItem('cerpsMemberType').includes('erpMember')) ? '/erpMemberPasswordChange' : '/erpTeacherPasswordChange'),
        params: {
          idCard: self.memberInfo.idCard,
          newPasswd: CryptoJS.MD5(self.passwdNewCheck).toString(),
          passwd: CryptoJS.MD5(self.passwdOld).toString(),
        }
      }
      this.$http(request).then(function(response) {
        console.log(response)
        console.log(response.data.msg)
        if(response.data.msg=='失敗'){
          self.$refs.ShowMsg.open(0,'輸入錯誤','請確認「舊密碼」')
          return
        }
        self.$refs.ShowMsg.open(12)
      }).catch(()=>{
        // self.$refs.ShowMsg.open(13)
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Pfl-7958')
      })
    },
  }
}
</script>